import React, { useCallback } from 'react';
import { setTempState, useTempState } from '@starflow/app/store';
import { SubWindow } from '@starflow/app/components/common/Window';
import { GenerationInfoPanelInner } from '@starflow/app/modules/generator/components/_legacy/info';

export const ImagesGenerateInfoWindow = React.memo(() => {
  // const generationWindowId = useTempState('generationWindowId');
  const left = useTempState('generationWindowLeft');
  const top = useTempState('generationWindowTop');
  const image = useTempState('thumbImageInfo');
  const genInfo = useTempState('thumbGenerationInfo');

  const width = Math.round(image?.width * (image.scaleX || 1));
  const height = Math.round(image?.height * (image.scaleY || 1));

  const handleCustomModalClose = useCallback(() => {
    setTempState({ generationWindowId: null });
    setTempState({ generationWindowLeft: null });
    setTempState({ generationWindowTop: null });
    setTempState({ thumbImageInfo: null });
    setTempState({ thumbGenerationInfo: null });
    setTempState({ exclusiveWindow: null });
  }, []);

  return (
    <SubWindow
      className="w-[300px] image-generate-info-window"
      name="images-generate-info-window"
      disableHeader
      positionSetter={() => ({ x: left, y: top })}
      handleCustomClose={handleCustomModalClose}
    >
      <GenerationInfoPanelInner image={image} genInfo={genInfo} imageWidth={width} imageHeight={height} />
    </SubWindow>
  );
});
